import {Component, Prop, Vue} from "vue-property-decorator";
import {fetchTilesetResult, getTileSet} from "~/modules/geo/service";
import {isDefined} from "~/lib/helpers/guards";
import {Loader} from "~/components/loader";

type Territory = {
  tsId: number;
  geoCodes: string[];
}
type TerritoryEntity = {
  gId: number;
  geoCode: string;
  name: string;
}

@Component
export class TerritoryListComponent extends Vue {

  @Prop({type: Object}) territory: Territory;

  private entities: TerritoryEntity[] = [];
  private tileSet = null;
  private isLoading = false;

  async created() {
    this.isLoading = true;

    if (this.territory) {

      let [entities, tileSet] = await Promise.all([
        fetchTilesetResult(this.territory),
        getTileSet(this.territory.tsId)
      ]);

      this.entities = entities;
      this.tileSet = tileSet;
    }

    this.isLoading = false;
  }

  render() {

    if (!isDefined(this.territory)) {
      return <p>France entière</p>;
    }

    if (this.isLoading) return <Loader/>;

    return (
      <div class="territory-list">
        <label class="label">{this.tileSet.label}</label>
        <ul>
          {this.entities.map(entity => <li>{entity.name} - {entity.geoCode}</li>)}
        </ul>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0f6ccc1d/territory-list.tsx" });